// Following Processing Class Ids can be checked from DB table ent.processing_class;

export enum ProcessingClass {
  Medical = 1,
  Funeral = 3
}

export enum ProcessingClassDisplayValue {
  Medical = 'Medical',
  Funeral = 'Funeral'
}
